import moment from 'moment';
import store from '@/js/store';

export function notify({
            title="Alert",
            msg='Notification Created',
            notify_type='alert',
            group='notify',
            ignoreDuplicates=true,
            pauseOnHover=true
            }) 
            {
            this.$notify({
                group: group,
                title: title,
                text: msg,
                type: notify_type,
                duration: 2500,
                ignoreDuplicates:true,
                pauseOnHover:true

            });
        }

export function log(value = 'Log:') {
  console.log(value);
}

export function checkPasswordStrength(password = '') {
  const strongPassword = new RegExp('(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{6,})');
  const mediumPassword = new RegExp(
    '((?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^A-Za-z0-9])(?=.{4,}))|' +
    '((?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9])(?=.{6,}))'
  );

  const strength = {
    strong: strongPassword.test(password),
    medium: mediumPassword.test(password),
    weak: password.length < 8,
  };

  return strength;
}

//  Time & formatting helpers
export function humanReadableTime(value) {
  return moment(value).fromNow();
}

export function formatDate(date) {
  return moment(date).format("MMM DD, YYYY");
}

export function formatedAmount(value) {
  return new Intl.NumberFormat().format(value);
}

export function commaSeparator(value) {
  if (value == null) return '';
  return Number(value).toFixed(2).toLocaleString();
}

//  String utilities
export function capitalizeString(input = '') {
  return input
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export function firstUpperThenLower(name = '') {
  name = name.toLowerCase();
  return name.charAt(0).toUpperCase() + name.slice(1);
}

export function uppercase(v = '') {
  return v.toUpperCase();
}

//  Numeric filters
export function decimalChecker(value) {
  if (!value) return '';
  const x = value.toString().split('.')[1];
  return x === '00' ? parseInt(value).toFixed() : value;
}

export function filterInt(value) {
  return /^(\-|\+)?([0-9]+|Infinity)$/.test(value) ? Number(value) : NaN;
}

export function filterFloat(value) {
  return /^\d+(\.\d{1,2})?$/.test(value) ? Number(value) : NaN;
}

export function round(value = 0, decimals = 0) {
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals);
}

export function percentage(value = 0, decimals = 0) {
  value *= 100;
  return Math.round(value * Math.pow(10, decimals)) / Math.pow(10, decimals) + '%';
}

export function isDecimalNumber(value) {
  return typeof value === 'number' && Number(value).toString() === value.toString() && value % 1 !== 0 && value > 0;
}
export function setInvoiceTitle(brandName, title) {
  if (brandName && title) {
    document.title = `${brandName} ${title}`;
  } else if (brandName) {
    document.title = brandName;
  } else if (title) {
    document.title = title;
  } else {
    document.title = 'OrderCircle';
  }
}

/**
 * Convert absolute URLs to relative paths so nginx/Vite proxy can serve them.
 * This avoids CORS and mixed-content issues in PDF components.
 */
export function resolveAssetUrl(path) {
  if (!path || typeof path !== 'string') return ''

  // If it's a full URL (http:// or https://), extract just the pathname
  try {
    const url = new URL(path)
    return url.pathname + url.search + url.hash
  } catch {
    // Not a valid URL — treat as already-relative
  }

  // Ensure it starts with /
  if (!path.startsWith('/')) {
    path = '/' + path
  }

  return path
}

/**
 *  Build a brand-domain image URL from an upload path.
 */
export function getBrandImageUrl(path = '') {
  const host = window.location.hostname;
  // Brand subdomain from Vuex; fallback to the current host subdomain.
  const brandSubdomain = store.getters.brand?.subdomain || host.split('.')[0];
  // Use configured app domain.
  const siteDomain = import.meta.env.VITE_APP_DOMAIN;
  if (!path || typeof path !== 'string') return '';
  if (/^https?:\/\//.test(path)) return path;

    return brandSubdomain && siteDomain ? `https://${brandSubdomain}.${siteDomain}/${path.replace(/^\/+/, '')}` : '';
}